/* eslint-disable react/prop-types */
import assetify from "@quintype/framework/assetify";
import Axios from "axios";
import get from "lodash/get";
import React, { useState } from "react";
import { useSelector } from "react-redux";
import { newsletterData } from "../../../constants";
import { Button } from "../../atoms/button";
import { TextField } from "../../atoms/textfield";

import LoadingIcon from "../../../../assets/images/loader.svg";
import "./stop-press.m.css";

const mailchimpListIds = [
  {
    name: "NL Events",
    listId: "3cf030021e"
  },
  {
    name: "Mic Drop",
    listId: "82e2052fcc"
  },
  {
    name: "Stop Press",
    listId: "a2ab56c30d"
  },
  {
    name: "न्यूज़लॉन्ड्री डाक",
    listId: "aa2c780e6c"
  },
  {
    name: "NL Digest",
    listId: "c6b749d171"
  },
  {
    name: "So Sketchy",
    listId: "b7fd7fb036"
  },
  {
    name: "रोज़नामचा",
    listId: "72e185d922"
  }
];

const StopPress = ({ collection, planName }) => {
  const domainSlug = useSelector(state =>
    get(state, ["qt", "domainSlug"], null)
  );
  const name = get(collection, ["associated-metadata", "name"], "Stop Press");
  const { member, fetchSubscription } = useSelector(state => state);

  const getPlanName = planName || name;

  const getPlanDetails =
    mailchimpListIds.find(item => item.name === getPlanName.trim()) || [];

  const getPlanDescription = newsletterData.find(
    item => item.listId === getPlanDetails.listId
  );

  const [showLoader, setShowLoader] = useState();
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [prompt, setPrompt] = useState(null);

  const firstName = member
    ? member["first-name"]
      ? member["first-name"]
      : member.name
    : "";

  const lastName = member ? member["last-name"] : "";

  const pushToDataLayer = (event, title) => {
    const obj = {
      event: event,
      subscription_category: title,
      usertype: member ? "logged in" : "logged out",
      subscribertype: fetchSubscription.isActive
        ? "subscriber"
        : "nonsubscriber",
      userID: member ? member.id : "null",
      subscriptionID: fetchSubscription.isActive
        ? fetchSubscription.items.find(sub => sub.active === true).id
        : "null"
    };

    window.dataLayer.push(obj);
  };

  const handleSubmit = async e => {
    e.preventDefault();

    if (
      getPlanDetails.listId === "82e2052fcc" ||
      getPlanDetails.listId === "3cf030021e"
    ) {
      setError(
        "This newsletter is not active anymore. Please visit our newsletter page to sign up for other newsletters"
      );
      return;
    }

    try {
      setShowLoader(true);

      await Axios.post(
        `/newsletter-api/lists/${getPlanDetails.listId}/members`,
        {
          email,
          firstName,
          lastName
        }
      );

      setShowLoader(false);
      pushToDataLayer("nl_article", "newsletter_subscription");
      setPrompt("Thanks for signing up. See you in your inbox soon.");

      setTimeout(() => {
        setEmail("");
        setPrompt(null);
      }, 3000);
    } catch (error) {
      setError(error.message);
      setShowLoader(false);
    }
  };

  return (
    getPlanDetails && (
      <div styleName="stop-process-container">
        <h3 styleName="stop-process">
          <span styleName="stop">{getPlanDetails.name}</span>
        </h3>
        <p styleName="description">{getPlanDescription.description}</p>
        {!domainSlug ? (
          <div styleName="subcribe-bottom">
            <form styleName="subscribe-view-content" onSubmit={handleSubmit}>
              <TextField
                type="email"
                required
                value={email}
                error={error}
                onChange={e => setEmail(e.target.value)}
                placeholder="Type your email"
              />
              <Button>Sign Up</Button>
            </form>
          </div>
        ) : (
          <div styleName="btn-input">
            {showLoader === true && (
              <div styleName="modal">
                <div styleName="modal-content">
                  <img src={assetify(LoadingIcon)} alt="loading" />
                </div>
              </div>
            )}
            <form styleName="subscribe-view-content" onSubmit={handleSubmit}>
              <TextField
                type="email"
                required
                value={email}
                error={error}
                onChange={e => setEmail(e.target.value)}
                placeholder="Type your email"
              />
              <button styleName="submit-btn">
                {!domainSlug ? "Sign up" : "साइन अप"}
              </button>
            </form>
          </div>
        )}
        {prompt && (
          <div styleName="modal">
            <div styleName="modal-content show-message">{prompt}</div>
          </div>
        )}
      </div>
    )
  );
};

export default StopPress;
